import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";
import "./styles/footer.css";

const Footer = () => (
	<footer className="site-footer">
		<div className="section-shell footer-shell">
			<div className="footer-brand">
				<strong>Lunexa Labs</strong>
				<span>Independent products, built with care.</span>
			</div>

			<nav aria-label="Footer navigation">
				<Link to="/">Home</Link>
				<Link to="/projects">Work</Link>
				<Link to="/software-development-lifecycle">Services</Link>
				<Link to="/about">About</Link>
				<Link to="/contact">Contact</Link>
				<Link to="/privacy">Website privacy</Link>
				<Link to="/apps/touch-point">Touch Count</Link>
				<Link to="/apps/touch-point/terms">Touch Count terms</Link>
				<Link to="/apps/touch-point/privacy">Touch Count privacy</Link>
			</nav>

			<div className="footer-meta">
				<a href={`mailto:${INFO.main.email}`}>{INFO.main.email}</a>
				<span>©2026 Lunexa Labs</span>
			</div>
		</div>
	</footer>
);

export default Footer;
